module.exports = __webpack_public_path__ + "static/img/15.4d9a7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/15.png
// module id = dND5
// module chunks = 0